// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Core__List from "@rescript/core/src/Core__List.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Utils$OrcaPaymentPage from "../Utils.bs.js";
import * as ApiEndpoint$OrcaPaymentPage from "../ApiEndpoint.bs.js";

function buildQueryParams(params) {
  if (params) {
    return Core__List.reduce(Core__List.map(params, (function (param) {
                      return param[0] + "=" + param[1];
                    })), "", (function (acc, param) {
                  if (acc === "") {
                    return "?" + param;
                  } else {
                    return acc + "&" + param;
                  }
                }));
  } else {
    return "";
  }
}

var CommonUtils = {
  buildQueryParams: buildQueryParams
};

function generateApiUrlV1(params, apiCallType) {
  var forceSync = params.forceSync;
  var clientSecret = params.clientSecret;
  var clientSecretVal = Core__Option.getOr(clientSecret, "");
  var publishableKeyVal = Core__Option.getOr(params.publishableKey, "");
  var paymentIntentID = Utils$OrcaPaymentPage.getPaymentId(clientSecretVal);
  var pollIdVal = Core__Option.getOr(params.pollId, "");
  var payoutIdVal = Core__Option.getOr(params.payoutId, "");
  var authenticationIdVal = Core__Option.getOr(params.authenticationId, "");
  var merchantId = Core__Option.getOr(params.merchantId, "");
  var baseUrl = Core__Option.getOr(params.customBackendBaseUrl, ApiEndpoint$OrcaPaymentPage.getApiEndPoint(publishableKeyVal, undefined));
  var isRetrieveIntent;
  isRetrieveIntent = apiCallType === "RetrievePaymentIntent" ? true : false;
  var match = Utils$OrcaPaymentPage.getNonEmptyOption(params.sdkAuthorization);
  var defaultParams = Core__List.filterMap({
        hd: match !== undefined || clientSecret === undefined ? undefined : [
            "client_secret",
            clientSecret
          ],
        tl: {
          hd: forceSync !== undefined && isRetrieveIntent ? [
              "force_sync",
              forceSync
            ] : undefined,
          tl: /* [] */0
        }
      }, (function (x) {
          return x;
        }));
  var queryParams;
  switch (apiCallType) {
    case "FetchPaymentMethodList" :
    case "FetchCustomerPaymentMethodList" :
    case "RetrievePaymentIntent" :
        queryParams = defaultParams;
        break;
    default:
      queryParams = /* [] */0;
  }
  var path;
  switch (apiCallType) {
    case "FetchPaymentMethodList" :
        path = "account/payment_methods";
        break;
    case "FetchCustomerPaymentMethodList" :
        path = "customers/payment_methods";
        break;
    case "FetchSessions" :
        path = "payments/session_tokens";
        break;
    case "FetchThreeDsAuth" :
        path = "payments/" + paymentIntentID + "/3ds/authentication";
        break;
    case "CalculateTax" :
        path = "payments/" + paymentIntentID + "/calculate_tax";
        break;
    case "CreatePaymentMethod" :
        path = "payment_methods";
        break;
    case "RetrievePaymentIntent" :
        path = "payments/" + paymentIntentID;
        break;
    case "CallAuthLink" :
        path = "payment_methods/auth/link";
        break;
    case "CallAuthExchange" :
        path = "payment_methods/auth/exchange";
        break;
    case "RetrieveStatus" :
        path = "poll/status/" + pollIdVal;
        break;
    case "ConfirmPayout" :
        path = "payouts/" + payoutIdVal + "/confirm";
        break;
    case "FetchEnabledAuthnMethodsToken" :
        path = "authentication/" + authenticationIdVal + "/enabled_authn_methods_token";
        break;
    case "FetchEligibilityCheck" :
        path = "authentication/" + authenticationIdVal + "/eligibility-check";
        break;
    case "FetchAuthenticationSync" :
        path = "authentication/" + merchantId + "/" + authenticationIdVal + "/sync";
        break;
    case "FetchPaymentMethodEligibility" :
        path = "payments/" + paymentIntentID + "/eligibility";
        break;
    
  }
  return baseUrl + "/" + path + buildQueryParams(queryParams);
}

function generateApiUrlV2(params, apiCallType) {
  var publishableKeyVal = Core__Option.getOr(params.publishableKey, "");
  var pid = Core__Option.getOr(params.paymentId, "");
  var baseUrl = Core__Option.getOr(params.customBackendBaseUrl, ApiEndpoint$OrcaPaymentPage.getApiEndPoint(publishableKeyVal, undefined));
  var path;
  switch (apiCallType) {
    case "GetIntentV2" :
        path = "v2/payments/" + pid + "/get-intent";
        break;
    case "ConfirmIntentV2" :
        path = "v2/payments/" + pid + "/confirm-intent";
        break;
    case "PaymentStatusV2" :
        path = "v2/payments/" + pid;
        break;
    case "ListPaymentMethodsV2" :
        path = "v2/payments/" + pid + "/payment-methods";
        break;
    case "CheckoutCryptoInstructionV2" :
        path = "v2/payments/" + pid + "/crypto/invoice/checkout";
        break;
    case "CreateExternalSdkTokensV2" :
        path = "v2/payments/" + pid + "/create-external-sdk-tokens";
        break;
    
  }
  return baseUrl + "/" + path;
}

function v2ClientAuthHeaders(publishableKey, clientSecret, profileId) {
  return [
          [
            "Content-Type",
            "application/json"
          ],
          [
            "Authorization",
            "publishable-key=" + publishableKey + ",client-secret=" + clientSecret
          ],
          [
            "x-profile-id",
            profileId
          ]
        ];
}

export {
  CommonUtils ,
  generateApiUrlV1 ,
  generateApiUrlV2 ,
  v2ClientAuthHeaders ,
}
/* Utils-OrcaPaymentPage Not a pure module */
